export const UpdateAttendeesFromContactListStyle = {
	title: {paddingTop: '96px', textAlign: 'start'},
	text: {marginBottom: '8px', textAlign: 'start', fontWeight: '400', color: 'var(--neutral-600)'},
	buttonWrapper: {
		padding: '18px 385px',
		background: 'var(--neutral-100)',
		width: '100%',
		position: 'absolute',
		bottom: '0',
		right: '0',
		left: '0',
	},
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		height: 'calc(100% - 128px)',
	},
};
